<script setup lang="ts">
//Components
import BreadCrumbNavigationTemplate from 'Common/components/templates/BreadCrumbNavigationTemplate.vue'
import DroneSpinner from 'Common/components/elements/feedback/DroneSpinner.vue'
import TitledPageTemplate from 'Common/components/templates/TitledPageTemplate.vue'
import ServerStatusViewHandler from 'Common/components/templates/ServerStatusViewHandler.vue'
//Modules
import InspectionsList from 'Modules/pages/aircraft/InspectionsList.vue'
import TailHeader from 'Modules/pages/aircraft/TailHeader.vue'
//Utils
import { useRouter } from 'vue-router'
import { computed } from 'vue'
//Store
import { useFilterStore } from 'Store/filterStore'
import { storeToRefs } from 'pinia'
//API
import { useGetAirCraftsFiltered } from 'API/queries/iris/aircraft'
import { useGetInspectionInstancesFiltered } from 'API/queries/iris/inspection-instance'
// Types
import type { BreadCrumbItem } from 'Common/types/utils/breadCrumbItem'

const router = useRouter()
const route = router.currentRoute
const aircraftUuid = route.value.params?.aircraftUUID
const filterStore = useFilterStore()
const { queryParamObj, areFiltersReady } = storeToRefs(filterStore)

const queryParams = computed(() => {
  return {
    ...queryParamObj.value,
    aircraft: [aircraftUuid],
  }
})

const { data: aircraftDetails, status: detailsStatus } = useGetAirCraftsFiltered({
  variables: {
    filterQueryParams: {
      aircraft: [aircraftUuid],
    },
  },
  enabled: areFiltersReady,
  refetchOnWindowFocus: false,
})

const { data: inspectionInstances, status: instancesStatus } = useGetInspectionInstancesFiltered({
  variables: {
    filterQueryParams: queryParams,
  },
  enabled: areFiltersReady,
  refetchOnWindowFocus: false,
})

const breadCrumbs = computed((): Array<BreadCrumbItem> => {
  return [{ label: 'Home', route: 'Home' }]
})
</script>

<template>
  <BreadCrumbNavigationTemplate :items="breadCrumbs">
    <template #main-content>
      <ServerStatusViewHandler :statuses="[detailsStatus, instancesStatus]">
        <template #loading>
          <div class="h-full w-full pb-10 flex items-center justify-center">
            <DroneSpinner />
          </div>
        </template>
        <template #error> ...error </template>
        <template #success>
          <TitledPageTemplate :title="aircraftDetails[0].tailNumber">
            <template #main-content>
              <div class="h-[calc(100%-42px)]">
                <div class="mb-7">
                  <TailHeader :plane-info="aircraftDetails[0] ? aircraftDetails[0] : null" />
                </div>
                <div class="">
                  <div class="text-left text-lg font-medium bg-slate-300 px-3 py-1 flex justify-between">
                    Inspections
                  </div>
                  <div class="h-[calc(100%-36px)]">
                    <InspectionsList :data="inspectionInstances ? inspectionInstances : []" />
                  </div>
                </div>
              </div>
            </template>
          </TitledPageTemplate>
        </template>
      </ServerStatusViewHandler>
    </template>
  </BreadCrumbNavigationTemplate>
</template>
